import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

const useCustomStyles = makeStyles()(() => ({
	imageWrapper: {
		position: 'relative',
		minHeight: '70vh',
	},
	image: {
		objectFit: 'contain',
	},
}));

export default useCustomStyles;
